"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceType = exports.device = exports.breakpoint = exports.LAPTOP_BREAKPOINT = exports.TABLET_BREAKPOINT = exports.MOBILE_BREAKPOINT = void 0;
exports.MOBILE_BREAKPOINT = 600;
exports.TABLET_BREAKPOINT = 1024;
exports.LAPTOP_BREAKPOINT = 4000;
exports.breakpoint = {
    mobile: exports.MOBILE_BREAKPOINT,
    tablet: exports.TABLET_BREAKPOINT,
    laptop: exports.LAPTOP_BREAKPOINT,
};
exports.device = {
    mobile: `(max-width: ${exports.breakpoint.mobile}px)`,
    tablet: `(max-width: ${exports.breakpoint.tablet}px)`,
    laptop: `(max-width: ${exports.breakpoint.laptop}px)`,
};
const getDeviceType = (width) => {
    if (width < exports.breakpoint.mobile) {
        return 'mobile';
    }
    else if (width < exports.breakpoint.tablet) {
        return 'tablet';
    }
    else {
        return 'laptop';
    }
};
exports.getDeviceType = getDeviceType;
//# sourceMappingURL=breakpoints.js.map